var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z",
    fill: "#E1E9F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_437_17069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7998 28.3252V11.4502C12.7998 11.1002 12.9123 10.8252 13.1373 10.6252C13.3623 10.4252 13.6248 10.3252 13.9248 10.3252C14.0248 10.3252 14.1248 10.3377 14.2248 10.3627C14.3248 10.3877 14.4248 10.4252 14.5248 10.4752L27.7998 18.9502C27.9748 19.0752 28.1061 19.2127 28.1936 19.3627C28.2811 19.5127 28.3248 19.6877 28.3248 19.8877C28.3248 20.0877 28.2811 20.2627 28.1936 20.4127C28.1061 20.5627 27.9748 20.7002 27.7998 20.8252L14.5248 29.3002C14.4248 29.3502 14.3248 29.3877 14.2248 29.4127C14.1248 29.4377 14.0248 29.4502 13.9248 29.4502C13.6248 29.4502 13.3623 29.3502 13.1373 29.1502C12.9123 28.9502 12.7998 28.6752 12.7998 28.3252Z",
    fill: "#1C53EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.106 9.56489L15.0583 9.53448L15.0078 9.50921C14.8432 9.42692 14.6693 9.36059 14.4867 9.31494C14.3037 9.26919 14.1158 9.2452 13.9248 9.2452C13.3593 9.2452 12.8417 9.44294 12.4198 9.81799C11.9259 10.257 11.7198 10.847 11.7198 11.4502V28.3252C11.7198 28.9284 11.9259 29.5184 12.4198 29.9574C12.8417 30.3325 13.3593 30.5302 13.9248 30.5302C14.1158 30.5302 14.3037 30.5062 14.4867 30.4605L14.4868 30.4604C14.6693 30.4148 14.8432 30.3485 15.0078 30.2662L15.0583 30.2409L15.106 30.2105L28.381 21.7355L28.4047 21.7204L28.4275 21.704C28.6979 21.5109 28.946 21.2662 29.1264 20.9569C29.3241 20.618 29.4048 20.2495 29.4048 19.8877C29.4048 19.5259 29.3241 19.1574 29.1264 18.8185C28.946 18.5092 28.6979 18.2645 28.4275 18.0714L28.4047 18.055L28.381 18.0399L15.106 9.56489Z",
    stroke: "white",
    strokeWidth: 2.16,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_437_17069",
    x: 5.83965,
    y: 3.36504,
    width: 29.4447,
    height: 33.0453,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0 0.504167 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_437_17069"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_437_17069",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.eedf66cab813680e45eb5e36620ffde1.svg";
export { ForwardRef as ReactComponent };